var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"list-item row"},[_c('div',[_vm._t("label")],2),_c('div',{class:_vm.$props.classNameItem},[_vm._t("value")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }